import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import ExtractedFiles from "./ExtractedFiles";
const ExtractedFilesTabContent = () => {
    return (React.createElement(ErrorBoundary, { key: "extracted-files" },
        React.createElement(ExtractedFiles, null)));
};
export default ExtractedFilesTabContent;
//# sourceMappingURL=ExtractedFilesTabContent.js.map